import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const PleaserNoMore: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <Block>
      <p>Welcome to the Pleaser no More program, where our main goal is to help
        you learn to feel your boundaries and say &quot;no&quot; without
        damaging relationships or feeling guilty.
      </p>

      <p>During the program, you will have access to specialized practices focused
        on developing and asserting your boundaries, as well as reducing guilt
        and fear of rejection when saying no.
      </p>

      <p>In addition, we offer a game where you can practice asserting your
        boundaries without damaging real-life relationships.
      </p>

      <p>Our therapy sessions focus on addressing the root causes of people-pleasing
        behaviors, such as subjugation schema, self-sacrifice schema, and approval-seeking
        schema. We also address Kahler&apos;s driver &quot;Please others&quot; and work on
        developing healthy ways to manage these schemas and drivers.
      </p>

      <p>Finally, we work on addressing internal voices that contribute
        to people-pleasing behavior, such as the surrender and guilt-inducing critic.
      </p>

      <p>We believe that this program will help you feel more confident in your ability
        to set boundaries and take care of your needs, without feeling guilty or
        damaging relationships. We are here to support and guide you every step of the way.
      </p>
    </Block>
  )
}
